import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

// Wrap the Responsive grid layout for proper handling of width
export const ResponsiveGridLayout = WidthProvider(Responsive);
